import React from 'react';

import { FormHandler, Label, Toggle } from 'Components/Form';
import { Card, CardBody } from 'Components/Card';
import { translation } from 'Services/TranslationHelpers';
import { Alert } from 'Components/Partials';
import { PrimaryButton } from 'Components/Button';

import MainStageSettings from 'Services/Api/Me/MainStageSettings';
import { User } from 'Services';

class UserSettings extends React.Component {
    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.props.setForm({
            ...User.data.main_stage_settings,
        });
    };

    /**
     * @method handleRequest
     * @param {object} data
     * @return {*}
     */
    handleRequest = (data) => MainStageSettings.patch(null, data);

    /**
     * @method handleSuccess
     * @return {Promise<void>}
     */
    handleSuccess = () => User.refresh();

    /**
     * @method render
     * @return {JSX.Element}
     */
    render () {
        const { alert, working, form, getFieldError, handleInput, handleSubmit } = this.props;

        return (
            <Card className="h-full bg-app-gray text-white  rounded-b-xl" bgColour="bg-app-blue" titleColor="text-white">
                <CardBody className="h-full flex flex-col">
                    <form onSubmit={(e) => handleSubmit(e, this.handleRequest, this.handleSuccess)}>
                        <h1 className="text-2xl font-bold" ref={ref => this.titleRef = ref}>
                            {translation('main_stage_frontend', 'user_settings')}
                        </h1>

                        <div className="h-full">
                            {alert && <Alert {...alert} />}

                            <div className="mb-4">
                                <Label
                                    error={getFieldError('reactions')}
                                    label={translation('main_stage_frontend', 'enable_reactions')}
                                />
                                <Toggle
                                    onChange={(v) => handleInput('reactions', v)}
                                    value={form.reactions}
                                />
                            </div>

                            <PrimaryButton
                                working={working}
                                text={translation('misc', 'save')}
                            />
                        </div>
                    </form>
                </CardBody>
            </Card>
        );
    }
}

export default FormHandler(UserSettings);
